import { useEffect } from "react"

import style from "./style.module.scss"

import { headTitle } from "modules/PsyProfile/ssg"
import {
    Labels,
    Experience,
    Titles,
    Location,
    Methods,
} from "modules/PsyProfile/components/Info/components"
import { Psychologist } from "utils/interfaces"
import { setPageTitle } from "utils/setPageTitle"
import { PsychologistAvatar } from "components/PsychologistAvatar/PsychologistAvatar"
import { useElementSize } from "utils/customHooks"
import { useShowPrice } from "utils/hooks/useShowPrice"

interface MainInfoProps {
    psy: Psychologist
}

export function Info({ psy }: MainInfoProps) {
    const [root] = useElementSize()
    const showPrice = useShowPrice()
    useEffect(() => {
        setPageTitle(headTitle(psy, showPrice))
    }, [])

    return (
        <section ref={root} className={style.container}>
            <div className={style.content}>
                <PsychologistAvatar
                    psy={psy}
                    className={style.avatar}
                    imgClassName={style.avatarImg}
                    data-testid="psy-profile-avatar"
                />
                <div className={style.info}>
                    <div className={style.infoHeader}>
                        <PsychologistAvatar
                            psy={psy}
                            className={style.avatarMobile}
                            imgClassName={style.avatarMobileImg}
                            data-testid="psy-profile-avatar-mobile"
                        />
                        <h1 className={style.title} data-testid="psy-profile-name">
                            {psy.display_name}
                        </h1>
                    </div>
                    <Labels psy={psy} />
                    <hr className={style.hr} />
                    <Titles psy={psy} />
                    <Methods psy={psy} />
                    <hr className={style.hr} />
                    <Experience psy={psy} />
                    <hr className={style.hr} />
                    <Location psy={psy} />
                </div>
            </div>
        </section>
    )
}
